
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"26","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M.007.038h27.404v23.846H.007z"}})]),_c('g',{attrs:{"transform":"translate(0 1)","fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M13.706 2.344A2.71 2.71 0 0016.287.473c-.703.193-1.599.31-2.581.31-.983 0-1.879-.117-2.581-.31a2.709 2.709 0 002.58 1.87z","fill":"#BDBDBD","mask":"url(#b)"}}),_c('path',{attrs:{"d":"M27.377 3.713a.626.626 0 00-.327-.359L21.824.941a25.294 25.294 0 00-3.387-.89.614.614 0 00-.72.47 4.116 4.116 0 01-4.011 3.214A4.116 4.116 0 019.694.52a.615.615 0 00-.72-.47 25.4 25.4 0 00-3.389.891L.361 3.354a.613.613 0 00-.326.36.608.608 0 00.033.483l2.268 4.478a.616.616 0 00.73.313l2.52-.747v15.024a.62.62 0 00.62.619h15a.62.62 0 00.619-.62V8.243l2.521.747a.62.62 0 00.729-.314l2.27-4.478a.62.62 0 00.032-.484z","fill":"#BDBDBD","mask":"url(#b)"}})])])
          )
        }
      }
    